<template>
  <div class="ed-switch" :class="{ 'ed-switch--disabled': disabled }">
    <div class="ed-switch__text" @click="toggleFromText">
      <div class="ed-switch__label">{{ label }}</div>
      <div v-if="hint" class="ed-switch__hint">{{ hint }}</div>
    </div>
    <v-switch
      :key="renderKey"
      :input-value="value"
      class="ed-switch__control"
      color="primary"
      hide-details
      :disabled="disabled"
      @change="onChange"
    ></v-switch>
  </div>
</template>

<script>
// Linha de configuração: texto à esquerda, chave liga/desliga à direita.
export default {
  name: "EditorSwitch",
  props: {
    value: Boolean,
    label: { type: String, required: true },
    hint: { type: String, default: null },
    disabled: Boolean,
  },
  data() {
    return { renderKey: 0 };
  },
  methods: {
    toggleFromText() {
      if (!this.disabled) this.onChange(!this.value);
    },
    onChange(value) {
      this.$emit("input", !!value);
      this.$emit("change", !!value);
      // Se o pai recusar a mudança (ex.: confirmação cancelada), recria o switch com o valor real.
      this.$nextTick(() => {
        if (this.value !== !!value) this.renderKey++;
      });
    },
  },
};
</script>

<style scoped>
.ed-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 12px 0;
  border-bottom: 1px solid var(--ced-border, #e3e5ec);
}
.ed-switch:first-child {
  padding-top: 0;
}
.ed-switch:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.ed-switch__text {
  cursor: pointer;
  min-width: 0;
}
.ed-switch--disabled .ed-switch__text {
  cursor: default;
  opacity: 0.6;
}
.ed-switch__label {
  font-size: 14px;
  color: var(--ced-text, #4c4d4f);
  line-height: 1.4;
}
.ed-switch__hint {
  font-size: 12px;
  color: var(--ced-muted, #80849a);
  margin-top: 2px;
  line-height: 1.45;
}
.ed-switch__control {
  flex: 0 0 auto;
  margin: 0;
  padding: 0;
}
</style>
